import { createContext } from 'react';

const defaultValue = {
  toggle: false,
  handleOpenQuote: () => {},
  handleClose: () => {},
  vehicleData: null,
  setVehicleData: () => {},
};

export const QuickQuoteContext = createContext(defaultValue);
export const QuickQuoteProvider = QuickQuoteContext.Provider;
export const QuickQuoteConsumer = QuickQuoteContext.Consumer;
